import React from 'react';
import {ServerComponentCaller} from '../helpers'


const HomeContainer = props => <ServerComponentCaller url={"assets/data/pages/home.json"}/>

HomeContainer.propTypes = {};

export default HomeContainer;
